import { Brain } from 'lucide-react';
import { cn } from '@/utils/classNames';
import { useReasoningToggle } from '@/hooks/useReasoningToggle';
import type { Agent } from '@/types/agent.types';

export interface ReasoningToggleProps {
  agent: Agent | undefined;
}

const PILL_BASE =
  'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ' +
  'transition-colors focus:outline-none focus:ring-2 focus:ring-stellar-primary';

const PILL_ON = 'bg-stellar-primary text-white';
const PILL_OFF =
  'border border-border-default text-text-secondary hover:bg-bg-secondary';

export function ReasoningToggle({ agent }: ReasoningToggleProps) {
  const { state, setEnabled, isVisible } = useReasoningToggle(agent?.id, agent);

  if (!isVisible) return null;

  return (
    <button
      type="button"
      aria-pressed={state.enabled}
      onClick={() => setEnabled(!state.enabled)}
      title="Use advanced thinking on the next prompt (slower, more thorough)"
      className={cn(PILL_BASE, state.enabled ? PILL_ON : PILL_OFF)}
    >
      <Brain className="h-3.5 w-3.5" aria-hidden="true" />
      <span>Think</span>
    </button>
  );
}
